import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils/utils";
interface HeadingProps {
  className?: string;
  title: string;
}
const Heading = t0 => {
  const $ = _c(5);
  const {
    className,
    title
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("font-black uppercase whitespace-nowrap leading-[0.8] text-[85px] md:text-[140px] lg:text-[160px] text-foreground drop-shadow-sm", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== title) {
    t2 = <h2 className={t1}>{title}</h2>;
    $[2] = t1;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default Heading;